import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { useAuth } from '../../hooks/useAuth';
import { NavigateWithRedirect } from '../NavigateWithRedirect';

export const UnverifiedUserLayout = () => {
  const { user, emailVerificationDetails } = useAuth();

  const { isEmailVerified } = emailVerificationDetails;

  if (!user) {
    return <NavigateWithRedirect to="/login" />;
  }

  if (isEmailVerified) {
    return <Navigate replace to="/dashboard" />;
  }

  return <Outlet />;
};
